import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonDirective,
  WcgDialogModule,
  WcgTextFieldAreaComponent,
} from '@wcg/frontend-framework';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ConfirmationsDialogData } from './table-confirmation-dialog.type';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  imports: [
    WcgDialogModule,
    MatDialogModule,
    MatButtonModule,
    ButtonDirective,
    CommonModule,
    ReactiveFormsModule,
    WcgTextFieldAreaComponent,
  ],
  selector: 'wcg-table-confirmation-dialog',
  styleUrls: ['./table-confirmation-dialog.component.scss'],
  templateUrl: './table-confirmation-dialog.component.html',
})
export class TableConfirmationDialogComponent {
  public readonly data = inject<ConfirmationsDialogData>(MAT_DIALOG_DATA);
  private readonly _dialogRef = inject(
    MatDialogRef<TableConfirmationDialogComponent>,
  );
  private readonly _fb = inject(FormBuilder);

  reasonForm = this._fb.group({
    reason: ['', Validators.required],
  });

  onConfirmClick(): void {
    if (!this.data.requiredReason) {
      this._dialogRef.close(true);
      return;
    }
    const reason = this.reasonForm.get('reason')?.value?.trim();
    if (!reason) {
      this.reasonForm.get('reason')?.markAsTouched();
      this.reasonForm.get('reason')?.updateValueAndValidity();
      return;
    }
    this._dialogRef.close({
      reason,
    });
  }
}
